import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ThemeSpaceKeys } from '../../styles/tokens/space';

type Columns = '1' | '2' | '3' | '4' | 'none';

export interface GridProps {
  desktopColumns?: Columns | string;
  mobileColumns?: Columns | string;
  as?: any;
  mobileGap?: ThemeSpaceKeys;
  desktopGap?: ThemeSpaceKeys;
  isProductsGrid?: boolean;
}

interface StyledGridProps {
  desktopColumns?: Columns | string;
  mobileColumns?: Columns | string;
  mobileGap?: ThemeSpaceKeys;
  desktopGap?: ThemeSpaceKeys;
  isProductsGrid?: boolean;
}

const StyledGrid = styled.div<StyledGridProps>`
  ${({
    theme: { space, media },
    mobileColumns,
    desktopColumns,
    mobileGap,
    desktopGap,
    isProductsGrid,
  }) => css`
    display: grid;
    gap: ${space[mobileGap || 'xSmall']};

    // Mobile > styles
    ${mobileColumns !== 'none' &&
    css`
      grid-template-columns: ${`repeat(${mobileColumns}, 1fr)`};
    `}

    // Desktop > styles
    ${desktopColumns !== 'none' &&
    css`
      @media (min-width: ${isProductsGrid ? media.large : media.medium}) {
        grid-template-columns: ${`repeat(${desktopColumns}, 1fr)`};
        gap: ${space[desktopGap || 'medium']};
      }
    `}

    ${isProductsGrid &&
    css`
      @media (min-width: ${media.large}) {
        margin-left: 1px;
      }
    `}
  `};
`;

export const Grid: FC<React.PropsWithChildren<GridProps>> = ({
  children,
  desktopColumns = '3',
  mobileColumns = 'none',
  mobileGap,
  desktopGap,
  isProductsGrid,
  as,
  ...rest
}) => (
  <StyledGrid
    mobileColumns={mobileColumns}
    desktopColumns={desktopColumns}
    mobileGap={mobileGap}
    desktopGap={desktopGap}
    isProductsGrid={isProductsGrid}
    as={as}
    {...rest}
  >
    {children}
  </StyledGrid>
);

export default Grid;
